import {Box, Typography} from "@mui/material";
import React, {useState} from "react";
import FaIcon from "@/components/utilities/fa-icon";
import {useTheme} from "@mui/material/styles";
import {PStarsProps} from "@/types/product";


export default function PStars({fixedRating, onClick,fontSize=24}: PStarsProps) {
    const [hoveredStar, setHoveredStar] = useState<number>(0);
    const stars = fixedRating ?? hoveredStar;
    const theme = useTheme()


    return (
        <Box
            textAlign = "center"
            onMouseLeave = {() => setHoveredStar(0)}
            display = "flex"
            flexDirection = "row-reverse"
            justifyContent="center"
            gap={.5}
        >
            {[5, 4, 3, 2, 1].map((i) => (
                <Box
                    display = "flex"
                    flexDirection = "column"
                    px={.5}
                    key = {i}
                    fontWeight={400}
                    color={i <= stars ? theme.palette.secondary.main : theme.palette.primary.light}
                    minWidth="unset"
                >
                    <Box onMouseEnter = {() => setHoveredStar(i)} lineHeight={1}>
                        <FaIcon
                            fontSize = {fontSize}
                            onClick = {() => onClick(i)}
                            sx = {{cursor: "pointer"}}
                            color = {i <= stars ? theme.palette.secondary.main : theme.palette.primary.light}
                            variant = {i <= stars ? "solid" : "light"}
                            faIcon = "fa-star"
                        />

                    </Box >
                        {i}

                </Box >
            ))}

        </Box >
    );
}
